import { render } from "./ResendKanryo.vue?vue&type=template&id=22ebf694&scoped=true"
import script from "./ResendKanryo.vue?vue&type=script&lang=js"
export * from "./ResendKanryo.vue?vue&type=script&lang=js"

import "./ResendKanryo.vue?vue&type=style&index=0&id=22ebf694&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ebf694"]])

export default __exports__